import { React, Component } from 'react';
import moment from 'moment';


export class EncabezadoSolicitud extends Component {


    render() {
        let data = this.props.Encabezado;
        return (

            <div id="DatosSolicitud" className="card shadow mb-4">
                <div className="card-header">
                    <h6 className="m-0 font-weight-bold text-primary">Datos de la Solicitud</h6>
                </div>
                <div className="card-body text-gray-800">
                    <div className="form-row">
                        <div className="form-group col-md-3">
                            <label htmlFor="Consecutivo" className="col-form-label">Número de Solicitud</label>
                            <input type="text" id="Consecutivo" className="form-control" value={data.consecutivo} readOnly />
                        </div>
                        <div className="form-group col-md-3">
                            <label htmlFor="IdPersonaTramite.TipoPersona" className="col-form-label">Tipo Persona</label>
                            <input type="text" id="IdPersonaTramite.TipoPersona" className="form-control" value={data.idPersonaTramite.tipoPersona.descripcionLarga} readOnly />
                        </div>
                        <div className="form-group col-md-3">
                            <label htmlFor="IdPersonaTramite.Codigo" className="col-form-label">Identificación</label>
                            <input type="text" id="IdPersonaTramite.Codigo" className="form-control" value={data.idPersonaTramite.codigo} readOnly />
                        </div>
                        <div className="form-group col-md-3">
                            <label htmlFor="Fecha" className="col-form-label">Fecha</label>
                            <input type="text" id="Fecha" className="form-control" value={ moment(data.fecha).format("DD/MM/YYYY HH:mm:ss")} readOnly />
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-md-3">
                            <label htmlFor="ClaseDato.NombreConId" className="col-form-label">Clase de Datos</label>
                            <input type="text" id="ClaseDato.NombreConId" className="form-control" value={data.claseDato.nombreConId} readOnly />
                        </div>
                        <div className="form-group col-md-3">
                            <label htmlFor="Entidad.Alias" className="col-form-label">Entidad</label>
                            <input type="text" id="Entidad.Alias" className="form-control" value={data.entidad.alias} readOnly />
                        </div>
                        <div className="form-group col-md-3">
                            <label htmlFor="TipoSolicitud.Nombre" className="col-form-label">Tipo de Solicitud</label>
                            <input type="text" id="TipoSolicitud.Nombre" className="form-control" value={data.tipoSolicitud.nombre} readOnly />
                        </div>
                        <div className="form-group col-md-3">
                            <label htmlFor="EstadoSolicitud.Nombre" className="col-form-label">Estado de Solicitud</label>
                            <input type="text" id="EstadoSolicitud.Nombre" className="form-control" value={data.estadoSolicitud.nombre} readOnly />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default EncabezadoSolicitud;

